export const queryKeys = {
  me: ['me'],
  locations: ['locations'],
  agents: ['agents'],
  agentTools: (id) => ['agents', id, 'tools'],
  knowledge: ['knowledge'],
  onCall: ['oncall'],
  businessHours: ['business-hours'],
  stats: {
    overview: (range) => ['stats', 'overview', range],
    analytics: (range) => ['stats', 'analytics', range]
  },
  users: {
    permissions: () => ['users', 'permissions'],
    list: () => ['users', 'list']
  },
  calls: {
    all: ['calls'],
    lists: () => ['calls', 'list'],
    list: (filters) => ['calls', 'list', filters],
    detail: (id) => ['calls', 'detail', id],
    recording: (id) => ['calls', 'recording', id]
  },
  messages: {
    all: ['messages'],
    conversationLists: () => ['messages', 'conversations'],
    conversations: (params) => ['messages', 'conversations', params],
    thread: (contactNumber) => ['messages', 'thread', contactNumber],
    suggestion: (contactNumber, lastId) => ['messages', 'suggestion', contactNumber, lastId]
  },
  templates: {
    all: ['templates'],
    list: () => ['templates', 'list']
  },
  contacts: {
    all: ['contacts'],
    list: (params) => ['contacts', 'list', params],
    detail: (contactNumber) => ['contacts', contactNumber]
  },
  messagingSettings: {
    all: ['messaging-settings'],
    detail: () => ['messaging-settings']
  },
  maintenance: {
    all: ['maintenance'],
    lists: () => ['maintenance', 'list'],
    list: (params) => ['maintenance', 'list', params]
  },
  vendors: {
    all: ['vendors'],
    lists: () => ['vendors', 'list'],
    list: (params) => ['vendors', 'list', params],
    summary: () => ['vendors', 'summary'],
    detail: (id) => ['vendors', 'detail', id]
  },
  owners: {
    all: ['owners'],
    lists: () => ['owners', 'list'],
    list: (params) => ['owners', 'list', params],
    detail: (id) => ['owners', 'detail', id]
  },
  properties: {
    all: ['properties'],
    lists: () => ['properties', 'list'],
    list: (params) => ['properties', 'list', params],
    detail: (id) => ['properties', 'detail', id]
  },
  scheduling: {
    all: ['scheduling'],
    bookings: () => ['scheduling', 'bookings'],
    bookingList: (params) => ['scheduling', 'bookings', params],
    assignees: () => ['scheduling', 'assignees'],
    availabilities: () => ['scheduling', 'availability'],
    availability: (params) => ['scheduling', 'availability', params]
  },
  clients: {
    all: ['clients'],
    lists: () => ['clients', 'list'],
    list: (params) => ['clients', 'list', params],
    detail: (id) => ['clients', 'detail', id]
  },
  prospects: {
    all: ['prospects'],
    lists: () => ['prospects', 'list'],
    list: (params) => ['prospects', 'list', params]
  },
  actions: {
    all: ['actions'],
    list: (window) => ['actions', 'list', window],
    detail: (id) => ['actions', 'detail', id]
  }
};
